"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MAX_REAL_WORLD_LOCATION_LENGTH = void 0;
exports.normalizeRealWorldLocation = normalizeRealWorldLocation;
exports.eventRequiresRealWorldLocation = eventRequiresRealWorldLocation;
exports.resolveRealWorldLocationForEvent = resolveRealWorldLocationForEvent;
exports.findProposedTimeEntry = findProposedTimeEntry;
exports.applyScheduledTimeToEvent = applyScheduledTimeToEvent;
exports.isScheduleEventLocationOpen = isScheduleEventLocationOpen;
exports.MAX_REAL_WORLD_LOCATION_LENGTH = 500;
function normalizeRealWorldLocation(value) {
    if (value === undefined || value === null) {
        return '';
    }
    return String(value).trim().slice(0, exports.MAX_REAL_WORLD_LOCATION_LENGTH);
}
function eventRequiresRealWorldLocation(event) {
    return event?.requiresRealWorldLocation === true;
}
/** Real-world location for proposal matching — ignored when the event does not require one. */
function resolveRealWorldLocationForEvent(event, rawLocation) {
    if (!eventRequiresRealWorldLocation(event)) {
        return undefined;
    }
    const loc = normalizeRealWorldLocation(rawLocation);
    return loc || undefined;
}
function findProposedTimeEntry(proposedTimes, startTimeEpochSeconds, realWorldLocation) {
    const times = Array.isArray(proposedTimes) ? proposedTimes : [];
    const loc = normalizeRealWorldLocation(realWorldLocation);
    return times.find((entry) => {
        if (Number(entry?.startTimeEpochSeconds) !== Number(startTimeEpochSeconds)) {
            return false;
        }
        const entryLoc = normalizeRealWorldLocation(entry?.realWorldLocation);
        if (loc === '' && entryLoc === '') {
            return true;
        }
        return entryLoc === loc;
    });
}
function applyScheduledTimeToEvent(event, startTimeEpochSeconds, realWorldLocation) {
    event.state = 'scheduled';
    event.scheduledTimeEpochSeconds = Number(startTimeEpochSeconds);
    const loc = normalizeRealWorldLocation(realWorldLocation);
    if (loc) {
        event.realWorldLocation = loc;
    }
    else {
        delete event.realWorldLocation;
    }
    event.proposedTimes = [];
}
/**
 * True when the event location should be available in the building (foyer links, location guidance).
 * Matches scheduled events whose start time has passed or is within the next hour, plus in-progress events.
 */
function isScheduleEventLocationOpen(event, nowSeconds) {
    if (!event) {
        return false;
    }
    if (event.state === 'in-progress') {
        return true;
    }
    if (event.state !== 'scheduled') {
        return false;
    }
    const start = Number(event.scheduledTimeEpochSeconds);
    if (!Number.isFinite(start) || start <= 0) {
        return false;
    }
    return start <= nowSeconds + 3600;
}
//# sourceMappingURL=scheduleEventHelpers.js.map